import React from "react";
import { Link } from "gatsby";
import "./project-details-header.css";

const ProjectDetails2Header = ({ projectHeaderData }) => {
  const getFullDate = (isoDate) => {
    const monthNames = [
      "Jan",
      "Feb",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    var date = new Date(isoDate);
    return (
      date.getDate() +
      " " +
      monthNames[date.getMonth()] +
      " " +
      date.getFullYear()
    );
  };
  return (
    <section
      className="page-header proj-det custom-project-header bg-img valign"
      style={{
        backgroundImage: `url(${projectHeaderData?.featureImage?.guid})`,
      }}
      data-overlay-dark="7"
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-7 col-md-9">
            <div className="cont">
              <h6>{projectHeaderData?.projectName}</h6>
              <h2>{projectHeaderData?.projectName}</h2>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-6 col-lg-3">
            <div className="item mt-30">
              <h5>Client</h5>
              <div>
                <Link to={projectHeaderData?.websiteURL} target="_blank">
                  {projectHeaderData?.projectName}
                </Link>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-3">
            <div className="item mt-30">
              <h5>Date</h5>
              <div>{getFullDate(projectHeaderData?.date)}</div>
            </div>
          </div>
          <div className="col-6 col-md-6 col-lg-3">
            {projectHeaderData?.technologies &&
              projectHeaderData?.technologies?.map((tech, index) => (
                <div className="item mt-30">
                  <h5>Tech Stack</h5>                  
                  <a href="javascript:void(0);" style={{ margin: 0 }}>
                      {(index ? ", " : "") + tech}
                  </a>                 
                </div>
              ))}
          </div>
          <div className="col-6 col-md-6 col-lg-3">
            {/* <div className="item mt-30">
              <h6>Tags</h6>
              <p>
                {projectHeaderData.tags.map((tag, index) => (
                  <Link to={tag.link} key={tag.id}>
                    {tag.name}
                    {projectHeaderData.tags.length != index + 1 ? " ," : ""}
                  </Link>
                ))}
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectDetails2Header;
